import React from "react"
import { useTranslation } from "react-i18next"
import { Button } from "@/components/ui/button"
import { cn } from "@/lib/utils"

interface MessageSelectionBarProps {
  selectedCount: number
  onCancel: () => void
  onForward: () => void
  className?: string
}

const MessageSelectionBar: React.FC<MessageSelectionBarProps> = ({
  selectedCount,
  onCancel,
  onForward,
  className,
}) => {
  const { t } = useTranslation()
  return (
    <div
      className={cn(
        "absolute inset-0 top-[56px] z-50 flex items-center justify-between border-t border-gray-200 bg-white p-4 dark:border-gray-700 dark:bg-gray-900",
        className,
      )}
    >
      <div className="flex items-center">
        <span className="text-sm font-medium text-gray-900 dark:text-gray-100">
          {t("chat.selectionBar.selected", { value: selectedCount })}
        </span>
      </div>

      <div className="flex items-center gap-2">
        <Button variant="outline" onClick={onCancel}>
          {t("common.cancel")}
        </Button>
        <Button
          onClick={onForward}
          disabled={selectedCount === 0}
          className="bg-blue-600 text-white hover:bg-blue-700"
        >
          {t("chat.forward.forward")}
        </Button>
      </div>
    </div>
  )
}

export default MessageSelectionBar
